export default __webpack_public_path__ + "static/media/dashboard_ic.6b624c49.svg";